export const UPLOAD_CONFIG = {
    MAX_FILES: 5,
    MAX_FILE_SIZE: 100 * 1024 * 1024, // 100MB in bytes
    MAX_FILE_SIZE_DISPLAY: "100 MB",
    // Add any other upload-related configurations here
    ACCEPTED_FILE_TYPES: {
        DOCUMENTS: ".csv,.doc,.docx,.pdf,.txt,.rtf,.odt,.xlsx,.xls,.ppt,.pptx",
        IMAGES: ".jpg,.jpeg,.png,.gif,.tif,.tiff",
        MEDIA: ".mp3,.mp4,.wav,.wmv,.mov,.flv,.mpeg",
        OTHER: ".odp,.ods,.xml",
    },
};
// Helper function to get human-readable file size
export const formatFileSize = (bytes) => {
    if (bytes === 0)
        return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};
// Helper to get a formatted list of accepted file types for display
export const getAcceptedFileTypesDisplay = () => {
    return Object.values(UPLOAD_CONFIG.ACCEPTED_FILE_TYPES)
        .join(",")
        .split(",")
        .map((ext) => ext.replace(".", ""))
        .join(", ");
};
// Helper to validate file extensions
export const validateFileExtensions = (files) => {
    const allowedExtensions = Object.values(UPLOAD_CONFIG.ACCEPTED_FILE_TYPES)
        .join(",")
        .split(",")
        .map((ext) => ext.toLowerCase().trim());
    const invalidFiles = [];
    for (const file of files) {
        const fileName = file.name.toLowerCase();
        const extension = fileName.includes(".")
            ? "." + fileName.split(".").pop()
            : "";
        if (!allowedExtensions.includes(extension)) {
            invalidFiles.push(file.name);
        }
    }
    if (invalidFiles.length > 0) {
        return {
            isValid: false,
            error: `Invalid file type(s): ${invalidFiles.join(", ")}.\nAccepted types: ${getAcceptedFileTypesDisplay()}`,
            invalidFiles,
        };
    }
    return { isValid: true };
};
